/* eslint-disable max-lines-per-function */
import { brand } from '@websrc/App/Helpers/brand'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { Link } from 'gatsby'
import React, { forwardRef } from 'react'

import { DarkCoralLogo } from './variants/DarkCoralLogo'
import { LightCoralLogo } from './variants/LightCoralLogo'

export interface CoralLogoProps {
  className?: string
  isDarkBackground?: boolean
  width?: number
}
export const CoralLogo = forwardRef<SVGSVGElement, CoralLogoProps>((props, ref) => {
  const locale = useLocale()
  const { className, isDarkBackground, width = 148 } = props

  return (
    <Link
      aria-label={brand.name}
      className={className}
      style={{ width: `${width}px`, minWidth: `${width}px`, display: 'flex' }}
      to={`/${locale}`}
    >
      {isDarkBackground ? <LightCoralLogo ref={ref} /> : <DarkCoralLogo ref={ref} />}
    </Link>
  )
})
